// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function UpdateIntentOverlay(props) {
  var isUpdateIntentLoading = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isUpdateIntentLoading);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: isUpdateIntentLoading,
              children: React.createElement("div", {
                    className: "absolute inset-0 flex flex-col items-center justify-center gap-2 backdrop-blur-sm bg-white/40 z-[999] rounded-[inherit]"
                  }, React.createElement("div", {
                        className: "w-6 h-6 animate-spin rounded-full border-3 border-black/10 border-t-black/60"
                      }), React.createElement("div", {
                        className: "text-fs-13 text-black/55 tracking-[0.2px]"
                      }, match.localeString.refreshingText))
            });
}

var make = UpdateIntentOverlay;

export {
  make ,
}
/* jotai Not a pure module */
